import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { showSnackbar } from '@/stores/snackbarStore';

/**
 * Handles OAuth callback by checking for token in URL params.
 * If found, logs the user in and clears the URL.
 */
export function useOAuthCallback() {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const handleOAuthCallback = useAuthStore((state) => state.handleOAuthCallback);
  const isHandling = useRef(false);

  useEffect(() => {
    const token = searchParams.get('token');

    if (token && !isHandling.current) {
      isHandling.current = true;

      // Clear the token from URL immediately
      searchParams.delete('token');
      setSearchParams(searchParams, { replace: true });

      // Handle the OAuth callback
      handleOAuthCallback(token)
        .then(() => {
          showSnackbar('Successfully logged in with Google!', 'success', 3000);
          navigate('/', { replace: true });
        })
        .catch((error) => {
          console.error('OAuth callback failed:', error);
          showSnackbar('Login failed. Please try again.', 'error', 5000);
          navigate('/login', { replace: true });
        })
        .finally(() => {
          isHandling.current = false;
        });
    }
  }, [searchParams, setSearchParams, handleOAuthCallback, navigate]);
}
